<template>
    <app-layout>
        <base-header :back-url="route('reviews.index')" :shadow="false" border
                     border-bg-from="from-amber-500"
                     border-bg-to="to-red-500"
        >
            <div class="flex items-center justify-between w-full">
                <div v-if="reviewable">
                    <h4 class="text-xl font-medium flex space-x-2 items-center">{{ $t('general.review') }}</h4>
                    <h4 class="text-lg font-medium flex space-x-2 items-center">
                        {{ review.type === 'budget' ? $t('general.budget') : $t('general.budget-projection') }}
                        {{ reviewable.year }}
                        <span v-if="reviewable && reviewable.name">
                            &nbsp;- {{ reviewable.name }}
                        </span>
                    </h4>
                    <div class="flex flex-col">
                        <span>
                            {{ store.name }}
                        </span>
                    </div>
                </div>

                <div v-else class="flex flex-col space-y-1">
                    <element-placeholder height="h-6" width="w-80"/>
                    <element-placeholder width="w-96"/>
                    <element-placeholder width="w-64"/>
                </div>

                <action-bar v-if="!isLocked">
                    <default-button
                        :disabled="isSubmitting"
                        :loading="isSubmitting"
                        color="red"
                        icon="x"
                        @click.native="openSubmitModal(false)"
                    >
                        {{ $t('review.reject') }}
                    </default-button>

                    <default-button
                        :disabled="isSubmitting"
                        :loading="isSubmitting"
                        color="green"
                        icon="check"
                        @click.native="openSubmitModal(true)"
                    >
                        {{ $t('review.approve') }}
                    </default-button>
                </action-bar>
            </div>
        </base-header>

        <budget-review
            v-if="review.type === 'budget'"
            :review="review"
            :reviewable="reviewable"
            :store="store"
            @update:locked="isLocked = $event"
        />

        <budget-projection-review
            v-else-if="review.type === 'budget_projection'"
            :review="review"
            :reviewable="reviewable"
            :store="store"
            @update:locked="isLocked = $event"
        />

        <element-modal :open="isSubmitModalOpen" :title="$t('review.submit')" @close="closeSubmitModal">
            <template #body>
                <form-label has-margin>{{ $t('general.comment') }}</form-label>

                <textarea v-model="comment" class="w-full rounded-md p-2 text-gray-900"/>
            </template>

            <template #footer>
                <save-button @click.native="submitReview"/>
            </template>
        </element-modal>
    </app-layout>
</template>

<script>
import Store from '@/Models/Store';
import Review from '@/Models/Review';
import BudgetReview from '@/Pages/Reviews/Components/BudgetReview';
import BudgetProjectionReview from '@/Pages/Reviews/Components/BudgetProjectionReview';

export default {
    components: {BudgetProjectionReview, BudgetReview},

    props: {
        review: Review,
        store: Store,
        reviewable: Object,
    },

    metaInfo() {
        return {
            title: this.$t('general.review'),
        };
    },

    data: function() {
        return {
            isSubmitting: false,
            isSubmitModalOpen: false,
            approved: null,
            comment: '',
            isLocked: true,
        };
    },

    methods: {
        openSubmitModal(approved) {
            this.approved = approved;
            this.isSubmitModalOpen = true;
        },

        closeSubmitModal() {
            this.approved = null;
            this.isSubmitModalOpen = false;
        },

        submitReview() {
            if (this.approved === null) {
                return;
            }

            this.isSubmitting = true;

            axios.post(route('api.reviews.submit', [this.review.id]), {
                approved: this.approved,
                comment: this.comment,
            }).then(() => {
                this.isSubmitting = false;
                this.$inertia.visit(route('reviews.index'));
            });
        },
    },
};
</script>
